import { z } from "zod";

/**
 * Jediný zdroj pravdy pro validaci poptávky.
 * Sdílí ho klientský formulář (LeadForm) i odesílací vrstva (submit.ts).
 */
export const leadSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, "Uveďte jméno a příjmení.")
    .max(120, "Jméno je příliš dlouhé."),
  company: z
    .string()
    .trim()
    .min(2, "Uveďte název firmy.")
    .max(160, "Název firmy je příliš dlouhý."),
  companyId: z
    .string()
    .trim()
    .max(20, "IČO je příliš dlouhé.")
    .optional()
    .or(z.literal("")),
  email: z
    .string()
    .trim()
    .min(1, "Uveďte e-mail.")
    .email("Uveďte platný e-mail."),
  phone: z
    .string()
    .trim()
    .max(32, "Telefon je příliš dlouhý.")
    .optional()
    .or(z.literal("")),
  volume: z.string().trim().min(1, "Vyberte, kolik reklamací měsíčně řešíte."),
  assortment: z
    .string()
    .trim()
    .max(1200, "Text je příliš dlouhý.")
    .optional()
    .or(z.literal("")),
  wantTerms: z.boolean().optional().default(false),
  gdpr: z.boolean().refine((value) => value === true, {
    message: "Bez souhlasu se zpracováním osobních údajů nemůžeme poptávku vyřídit.",
  }),
});

export type LeadInput = z.input<typeof leadSchema>;
export type LeadValues = z.output<typeof leadSchema>;

export const emptyLeadValues: LeadInput = {
  name: "",
  company: "",
  companyId: "",
  email: "",
  phone: "",
  volume: "",
  assortment: "",
  wantTerms: false,
  gdpr: false,
};
